import { formatDistanceToNow } from 'date-fns';

/**
 * Format a number with locale formatting (thousands separators)
 */
export function formatNumber(value: number | null | undefined): string {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '0';
  }
  return value.toLocaleString();
}

/**
 * Format a cost value with 6 decimal places
 */
export function formatCost(value: number | null | undefined): string {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '$0.000000';
  }
  return `$${value.toFixed(6)}`;
}

/**
 * Format a timestamp (epoch seconds or milliseconds) to locale string
 */
export function formatTimestamp(value: number | null | undefined): string {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '—';
  }
  // Convert seconds to milliseconds if needed
  const milliseconds = value < 10_000_000_000 ? value * 1000 : value;
  const date = new Date(milliseconds);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}

/**
 * Format a timestamp as relative time (e.g., "3 days ago", "2 hours ago")
 */
export function formatRelativeTime(
  timestamp: number | null | undefined,
): string {
  if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
    return '—';
  }

  // Convert seconds to milliseconds if needed
  const milliseconds =
    timestamp < 10_000_000_000 ? timestamp * 1000 : timestamp;
  const date = new Date(milliseconds);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  try {
    return formatDistanceToNow(date, { addSuffix: true });
  } catch {
    return '—';
  }
}

/**
 * Format a date string to locale string
 */
export function formatDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleString();
}
